<template>
  <div class="animated fadeIn brief-abm">
    <b-row>
      <b-col cols="12">
        <b-card header="Información de la Acción">
          <b-form>
            <b-form-group
              v-if="id != 0"            
              label="Nro. Brief"
              label-for="id"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="id"
                :value="id"
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <template v-if="id == 0">
              <b-form-group
                label="Cliente"
                label-for="cliente"
                :label-cols="2"
                horizontal>
                <b-input-group>
                  <b-input-group-append 
                      class="filter-search-icons" 
                      @click="seleccionarCliente">
                    <b-input-group-text>
                      <i :class="{ 'fa fa-search': !cliente,
                                    'fa fa-remove': cliente  }"></i>
                    </b-input-group-text>
                  </b-input-group-append>
                  <b-form-input 
                    id="cliente"
                    :value="clienteNombre"
                    readonly
                    :state="clienteValido"
                    type="text"/>
                  <b-form-invalid-feedback id="clienteFeedback">
                    {{ clienteInvalidoMsj }}
                  </b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
  
              <b-form-group
                label="Accion"
                label-for="accion"
                :labelCols="labelCols"
                horizontal>
                <b-form-input 
                  id="accion"
                  v-model.trim="$v.accion.$model" 
                  :state="accionValida"
                  type="text"
                  @blur.native="validate">
                </b-form-input>
                <b-form-invalid-feedback id="accionFeedback">
                  {{ accionInvalidaMsj }}
                </b-form-invalid-feedback>
              </b-form-group>
  
              <app-tipo-presupuesto
                label="Tipo de Presup."
                :nombre="tipoPresupuestoNombre"
                :labelCols="labelCols"
                labelOption="Seleccione un tipo"
                :valido="tipoPresupuestoValido"
                :lista="tiposPresupuestosList"
                :msjInvalido="tipoPresupuestoInvalidoMsj"
                @validate="validate"
                @updated="tipoPresupuestoActualizado">
              </app-tipo-presupuesto>
            </template>

            <template v-if="id != 0">
              <b-form-group
                label="Cliente"
                label-for="cliente"
                :label-cols="2"
                horizontal>
                <b-form-input 
                  id="cliente"
                  :value="clienteNombre"
                  readonly
                  type="text"/>
              </b-form-group>
  
              <b-form-group
                label="Acción"
                label-for="accion"
                :labelCols="labelCols"
                horizontal>
                <b-form-input 
                  id="accion"
                  :value="accion" 
                  readonly>
                </b-form-input>
              </b-form-group>
  
              <b-form-group
                label="Tipo de Presupuesto"
                label-for="tipoPresupuesto"
                :labelCols="labelCols"
                horizontal>
                <b-form-input 
                  id="tipoPresupuesto"
                  :value="tipoPresupuestoNombre" 
                  readonly>
                </b-form-input>
              </b-form-group>
            </template>

            <app-canal
              label="Canal"
              :nombre="canalNombre"
              :labelCols="labelCols"
              labelOption="Seleccione un canal"
              :valido="canalValido"
              :lista="canalesList"
              :msjInvalido="canalInvalidoMsj"
              @validate="validate"
              @updated="canalActualizado">
            </app-canal>

            <!-- <b-form-group
              label="Canal"
              label-for="canal"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="canal"
                v-model.trim="$v.canal.$model" 
                :state="canalValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="canalFeedback">
                {{ canalInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group> -->

            <b-form-group
              label="Subcliente"
              label-for="subcliente"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="subcliente"
                v-model.trim="$v.subcliente.$model" 
                :state="subclienteValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="subclienteFeedback">
                {{ subclienteInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <!-- <b-form-group
              label="Nro. PI"
              label-for="presupuestosNumero"
              :labelCols="labelCols"
              description="Uno o más presupuestos internos asociados"
              horizontal>
              <b-form-input 
                id="presupuestosNumero"
                :value="presupuestosNumero"
                type="text"
                readonly>
              </b-form-input>
            </b-form-group> -->
          </b-form>
        </b-card>

        <app-presupuestos-internos 
          ref="presupuestosInternos"
          :presupuestosInternos="presupuestosInternos"
          @addPresupuestoInterno="addPresupuestoInterno"
          @deletePresupuestoInterno="deletePresupuestoInterno">
        </app-presupuestos-internos>

        <app-usuarios/>

        <b-card no-header>
          <b-tabs @input="setTabIndex" justified>
            <b-tab title="Especificaciones" active>
              <b-form>
                <b-form-group
                  label="Objetivo/Contexto del Pedido"
                  label-for="descripcion"
                  :labelCols="labelCols"
                  description="Detallar el pedido que realizó el cliente indicando aspectos generales de la campaña, objetivos, etc. para dar contexto a los/as diseñadores/as sobre esta solicitud."
                  horizontal>
                  <b-form-textarea
                    id="descripcion"
                    v-model="$v.descripcion.$model" 
                    rows="3"
                    :state="descripcionValida"
                    @blur.native="validate">
                  </b-form-textarea>
                  <b-form-invalid-feedback id="descripcionFeedback">
                    {{ descripcionInvalidaMsj }}
                  </b-form-invalid-feedback>
                </b-form-group>

                <app-tipos-disenios ref="tiposDisenios"/>

                <b-form-group
                  v-if="!mecanicaPromocionalVisible"
                  label="Especificaciones para Diseño"
                  label-for="requerimientosDisenio"
                  :labelCols="labelCols"
                  description="Indicar todos los detalles para armar el visual que luego se adaptará a las piezas o formatos necesarios."
                  horizontal>
                  <b-form-textarea
                    id="requerimientosDisenio"
                    v-model="$v.requerimientosDisenio.$model" 
                    rows="10"
                    :state="requerimientosDisenioValido"
                    @blur.native="validate">
                  </b-form-textarea>
                  <b-form-invalid-feedback id="requerimientosDisenioFeedback">
                    {{ requerimientosDisenioInvalidoMsj }}
                  </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group
                  v-if="descripcionAdicionales != ''"
                  label="Adicionales"
                  label-for="descripcionAdicionales"
                  :labelCols="labelCols"
                  horizontal>
                  <b-form-textarea
                    id="descripcionAdicionales"
                    :value="descripcionAdicionales" 
                    rows="3"
                    readonly>
                  </b-form-textarea>
                </b-form-group>

                <div v-if="!mecanicaPromocionalVisible"
                    class="especificaciones">
                  <label class="text-muted">Recordá incluir la siguiente información:</label>
                  <ul>
                    <li class="text-muted">Estética</li>
                    <li class="text-muted">Logos que deben estar presentes</li>
                    <li class="text-muted">Elementos o colores que no deben estar presentes</li>
                    <li class="text-muted">Todas las medidas necesarias</li>
                    <li class="text-muted">Cantidad de modelos</li>
                    <!-- <li class="text-muted">Imágenes de referencia</li> -->
                    <li class="text-muted">Necesidades específicas, por ej: espacios de guardado, estantes, etc</li>
                  </ul> 
                </div>
                <!-- <wysiwyg v-model="texto" :options="editorOptions" />-->
              </b-form>
            </b-tab>

            <b-tab title="Adjuntos">
              <app-imagenes/>
            </b-tab>

            <b-tab title="Marcas">
              <app-marcas 
                ref="marcas"
                @agregarMarca="agregarMarca"
                @editarMarca="editarMarca">
              </app-marcas>
            </b-tab>

            <b-tab title="Entrega">
              <b-form>
                <div class="subtitulo">
                  <label>Forma de Entrega</label>
                  <small class="text-muted">¿se va a imprimir? ¿se va a enviar editable? ¿solo será digital? Seleccionar todas las respuestas que correspondan.</small>
                </div>

                <b-list-group flush class="formas-entrega">
                  <b-list-group-item>
                    <b-form-checkbox 
                        id="formaEntregaEditable"
                        v-model="formaEntregaEditable"
                        value= true
                        unchecked-value= false>
                        Voy a necesitar editable
                    </b-form-checkbox>
                  </b-list-group-item>

                  <b-list-group-item>
                    <b-form-checkbox 
                      id="formaEntregaDigital"
                      v-model="formaEntregaDigital"
                      value= true
                      unchecked-value= false>
                      Las piezas serán solo digitales
                    </b-form-checkbox>
                  </b-list-group-item>

                  <b-list-group-item>
                    <b-form-checkbox 
                      id="formaEntregaImpresion"
                      v-model="formaEntregaImpresion"
                      value= true
                      unchecked-value= false>
                      Las piezas se van a imprimir
                    </b-form-checkbox>
                  </b-list-group-item>

                  <b-list-group-item>
                    <b-form-checkbox 
                      id="formaEntregaAdaptacion"
                      v-model="formaEntregaAdaptacion"
                      value= true
                      unchecked-value= false>
                      Voy a necesitar adaptaciones para PPT
                    </b-form-checkbox>
                  </b-list-group-item>

                  <b-list-group-item>
                    <b-form-checkbox 
                      id="formaEntregaIndefinida"
                      v-model="formaEntregaIndefinida"
                      value= true
                      unchecked-value= false>
                      Todavía no está definido
                    </b-form-checkbox>
                  </b-list-group-item>

                  <b-list-group-item>
                    <b-input-group>
                      <b-form-checkbox 
                          id="formaEntregaOtros"
                          v-model="formaEntregaOtros"
                          value= true
                          unchecked-value= false>
                          Otra
                      </b-form-checkbox>
                      <b-form-input 
                        id="formaEntregaOtrosDescripcion"
                        v-model.trim="$v.formaEntregaOtrosDescripcion.$model" 
                        :state="formaEntregaOtrosDescripcionValida"
                        type="text"
                        :readonly="!isFormaEntregaOtros"
                        class="custom-check-input"
                        @blur.native="validate">
                      </b-form-input>
                      <b-form-invalid-feedback id="formaEntregaOtrosDescripcionFeedback">
                        {{ formaEntregaOtrosDescripcionInvalidaMsj }}
                      </b-form-invalid-feedback>          
                    </b-input-group>
                  </b-list-group-item>
                </b-list-group>
                
                <br>
                <br>

                <div class="subtitulo">
                  <label class="titulo">Timing</label>
                  <small class="text-muted">Indicar las fechas estimadas de entrega</small>
                </div>
                
                <b-form-group
                  label="Primera Muestra"
                  label-for="fechaEntregaMuestra"
                  description="Fecha de entrega de primera muestra"
                  :label-cols="labelCols">
                  <b-input-group>
                    <b-input-group-prepend is-text>
                      <b-form-checkbox 
                          id="fechaEntregaMuestraHabilitada"
                          v-model="fechaEntregaMuestraHabilitada"
                          value= true
                          unchecked-value= false>
                      </b-form-checkbox>
                    </b-input-group-prepend>
                    <b-form-input 
                      id="fechaEntregaMuestra" 
                      v-model="$v.fechaEntregaMuestra.$model" 
                      type="datetime-local"
                      :disabled="fechaEntregaMuestraDisabled"
                      :state="fechaEntregaMuestraValida"
                      @blur.native="validate">
                    </b-form-input>
                  </b-input-group>
                  <b-form-invalid-feedback id="fechaEntregaMuestraFeedback">
                    {{ fechaEntregaMuestraInvalidaMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <b-form-group
                  label="Originales"
                  label-for="fechaEntregaOriginales"
                  description="Fecha de entrega de originales"
                  :label-cols="labelCols">
                  <b-input-group>
                    <b-input-group-prepend is-text>
                      <b-form-checkbox 
                          id="fechaEntregaOriginalesHabilitada"
                          v-model="fechaEntregaOriginalesHabilitada"
                          value= true
                          unchecked-value= false>
                      </b-form-checkbox>
                    </b-input-group-prepend>
                    <b-form-input 
                      id="fechaEntregaOriginales" 
                      v-model="$v.fechaEntregaOriginales.$model" 
                      type="datetime-local"
                      :disabled="fechaEntregaOriginalesDisabled"
                      :state="fechaEntregaOriginalesValida"
                      @blur.native="validate">
                    </b-form-input>
                  </b-input-group>
                  <b-form-invalid-feedback id="fechaEntregaOriginalesFeedback">
                    {{ fechaEntregaOriginalesInvalidaMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>

                <b-form-group
                  label="Implementación / Inicio"
                  label-for="fechaImplementacion"
                  description="Fecha de implementación o inicio de vigencia"
                  :label-cols="labelCols">
                  <b-input-group>
                    <b-input-group-prepend is-text>
                      <b-form-checkbox 
                          id="fechaImplementacionHabilitada"
                          v-model="fechaImplementacionHabilitada"
                          value= true
                          unchecked-value= false>
                      </b-form-checkbox>
                    </b-input-group-prepend>
                    <b-form-input 
                      id="fechaImplementacion" 
                      v-model="$v.fechaImplementacion.$model" 
                      type="datetime-local"
                      :disabled="fechaImplementacionDisabled"
                      :state="fechaImplementacionValida"
                      @blur.native="validate">
                    </b-form-input>
                  </b-input-group>
                  <b-form-invalid-feedback id="fechaImplementacionFeedback">
                    {{ fechaImplementacionInvalidaMsj }}
                  </b-form-invalid-feedback>          
                </b-form-group>
              </b-form>
            </b-tab>
          </b-tabs>
        </b-card>

        <b-card header="Mecánica Promocional" v-if="mecanicaPromocionalVisible">
          <b-form>
            <b-form-group
              label="Titular"
              label-for="titular"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="titular"
                v-model.trim="$v.titular.$model" 
                :state="titularValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="titularFeedback">
                {{ titularInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Mecánica"
              label-for="mecanica"
              :labelCols="labelCols"
              horizontal>
              <b-form-textarea
                id="mecanica"
                v-model="$v.mecanica.$model" 
                rows="3"
                :state="mecanicaValida"
                @blur.native="validate">
              </b-form-textarea>
              <b-form-invalid-feedback id="mecanicaFeedback">
                {{ mecanicaInvalidaMsj }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label="Premios"
              label-for="premios"
              :labelCols="labelCols"
              horizontal>
              <b-form-textarea
                id="premios"
                v-model="$v.premios.$model" 
                rows="3"
                :state="premiosValido"
                @blur.native="validate">
              </b-form-textarea>
              <b-form-invalid-feedback id="premiosFeedback">
                {{ premiosInvalidoMsj }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label="Pie Legal"
              label-for="pieLegal"
              :labelCols="labelCols"
              description="Incluir pie legal corto y largo de ser necesario"
              horizontal>
              <b-form-textarea
                id="pieLegal"
                v-model="$v.pieLegal.$model" 
                rows="3"
                :state="pieLegalValido"
                @blur.native="validate">
              </b-form-textarea>
              <b-form-invalid-feedback id="pieLegalFeedback">
                {{ pieLegalInvalidoMsj }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label="Adaptaciones"
              label-for="piezas"
              :labelCols="labelCols"
              description="Piezas a diseñar/adaptaciones. Incluir cantidades, medidas y modelos"
              horizontal>
              <b-form-textarea
                id="piezas"
                v-model="$v.piezas.$model" 
                rows="3"
                :state="piezasValido"
                @blur.native="validate">
              </b-form-textarea>
              <b-form-invalid-feedback id="piezasFeedback">
                {{ piezasInvalidoMsj }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              label="Especificaciones para Diseño"
              label-for="requerimientosDisenio"
              :labelCols="labelCols"
              description="Indicar todos los detalles para armar el visual que luego se adaptará a las piezas o formatos necesarios."
              horizontal>
              <b-form-textarea
                id="requerimientosDisenio"
                v-model="$v.requerimientosDisenio.$model" 
                rows="10"
                :state="requerimientosDisenioValido"
                @blur.native="validate">
              </b-form-textarea>
              <b-form-invalid-feedback id="requerimientosDisenioFeedback">
                {{ requerimientosDisenioInvalidoMsj }}
              </b-form-invalid-feedback>
            </b-form-group>

            <div class="especificaciones">
              <label class="text-muted">Recordá incluir la siguiente información:</label>
              <ul>
                <li class="text-muted">Estética</li>
                <li class="text-muted">Logos que deben estar presentes</li>
                <li class="text-muted">Elementos o colores que no deben estar presentes</li>
                <li class="text-muted">Todas las medidas necesarias</li>
                <li class="text-muted">Cantidad de modelos</li>
                <!-- <li class="text-muted">Imágenes de referencia</li> -->
                <li class="text-muted">Necesidades específicas, por ej: espacios de guardado, estantes, etc</li>
              </ul> 
            </div>
            
            <br>

            <label>A quien esta dirigida la acción?</label>
            <!-- <label class="titulo">A quien esta dirigida la acción?</label> -->

            <b-list-group flush class="accion-objetivos">
              <b-list-group-item>
                <b-form-checkbox 
                    id="accionPuntoVenta"
                    v-model="accionPuntoVenta"
                    value= true
                    unchecked-value= false>
                    Punto de Venta (Owners: dueños/encargados de PdV)
                </b-form-checkbox>
              </b-list-group-item>

              <b-list-group-item>
                <b-form-checkbox 
                    id="accionConsumidorFinal"
                    v-model="accionConsumidorFinal"
                    value= true
                    unchecked-value= false>
                    Consumidores Finales
                </b-form-checkbox>
              </b-list-group-item>

              <b-list-group-item>
                <b-form-checkbox 
                    id="accionFuerzaVenta"
                    v-model="accionFuerzaVenta"
                    value= true
                    unchecked-value= false>
                    Fuerza de Venta
                </b-form-checkbox>
              </b-list-group-item>

              <b-list-group-item>
                <b-input-group>
                  <b-form-checkbox 
                      id="accionOtros"
                      v-model="accionOtros"
                      value= true
                      unchecked-value= false>
                      Otra
                  </b-form-checkbox>
                  <b-form-input 
                    id="accionOtrosDescripcion"
                    v-model.trim="$v.accionOtrosDescripcion.$model" 
                    :state="accionOtrosDescripcionValida"
                    type="text"
                    :readonly="!isAccionOtros"
                    class="custom-check-input"
                    @blur.native="validate">
                  </b-form-input>
                  <b-form-invalid-feedback id="accionOtrosDescripcionFeedback">
                    {{ accionOtrosDescripcionInvalidaMsj }}
                  </b-form-invalid-feedback>          
                </b-input-group>
              </b-list-group-item>
            </b-list-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <b-modal ref="searchClienteModal" 
        title="Seleccionar Cliente"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="clientes-search-modal">
      <app-search-cliente
        @clienteSeleccionado="clienteSeleccionado">
      </app-search-cliente>  
    </b-modal>

    <b-modal ref="marcaModal"
        :title="tituloModalMarcas"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-marca-cliente
        :clienteId = "clienteId"
        :marcaId = "marcaId"
        :rowVersion = "marcaRowVersion"
        @saved = "marcaSaved"
        @close = "closeMarca">
      </app-marca-cliente>  
    </b-modal>

    <b-modal ref="searchPresupuestoInternoModal" 
        title="Seleccionar Presupuesto Interno"
        header-bg-variant="light" 
        hide-footer
        lazy
        modal-class="modalABM modalSearchPresupuesto">
      <app-search-presupuesto
        :soloPresupuestosAbiertos="true"
        :seleccionarOrden="false"
        :seleccionarSubtrabajo="false"
        @presupuestoInternoSeleccionado="presupuestoInternoSeleccionado"
        @cancelaSeleccionPresupuestoInterno="cancelaSeleccionPresupuestoInterno">
      </app-search-presupuesto>  
    </b-modal>

    <div class="fixed-btn">
      <!-- <div class="abm-save-continue-btn" 
        @click.prevent="save(true)"
        v-b-tooltip.hover title="Grabar y Continuar">
          <i class="fa fa-save" aria-hidden="true" style="position: relative; font-size: 1.6em; left: -2px; top: 3px;"></i>
          <i class="fa fa-share" aria-hidden="true" style="position: relative; font-size: 0.8em; left: -2px; top: -11px;"></i>
      </div> -->
      <div class="abm-save-btn" 
        @click.prevent="save(false)"
        v-b-tooltip.hover title="Grabar y Salir">
          <i class="fa fa-save fa-2x" aria-hidden="true"></i>
      </div>
      <div class="abm-cancel-btn" 
        @click.prevent="cancel"
        v-b-tooltip.hover title="Salir">
          <i class="fa fa-close fa-2x" aria-hidden="true"></i>
      </div>
    </div>
    
    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import SearchCliente from '../clientes/SearchList.vue';
import TipoPresupuesto from '../shared/abmSelect.vue';
import Canal from '../shared/abmSelect.vue';
import PresupuestosInternos from './PresupuestosInternosABM.vue';
import Usuarios from './Usuarios.vue';
import Marcas from './MarcasABM.vue';
import MarcaCliente from '../marcas/MarcaClienteABM.vue';
import TiposDisenios from './TiposDiseniosABM.vue';
import Imagenes from './ImagenesABM.vue';
import SearchPresupuesto from '../presupuestosinternos/Search.vue';
import Buttons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { required, maxLength } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'brief/getField',
  mutationType: 'brief/updateField',
});

export default {
  name: 'BriefABM',
  components: {
    appSearchCliente: SearchCliente,
    appTipoPresupuesto: TipoPresupuesto,
    appCanal: Canal,
    appPresupuestosInternos: PresupuestosInternos,
    appUsuarios: Usuarios,
    appMarcas: Marcas,
    appMarcaCliente: MarcaCliente,
    appTiposDisenios: TiposDisenios,
    appImagenes: Imagenes,
    appSearchPresupuesto: SearchPresupuesto,
    appButtons: Buttons,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal 
  ],
  data () {
    return {
      noValidar: true,
      clienteValido: null,
      clienteInvalidoMsj: '',
      accionValida: null,
      accionInvalidaMsj: '',
      tipoPresupuestoValido: null,
      tipoPresupuestoInvalidoMsj: '',
      canalValido: null,
      canalInvalidoMsj: '',
      subclienteValido: null,
      subclienteInvalidoMsj: '',
      descripcionValida: null,
      descripcionInvalidaMsj: '',
      // adicionalesValido: null,
      // adicionalesInvalidoMsj: '',
      // requerimientosValidos: null,
      // requerimientosInvalidosMsj: '',
      accionOtrosDescripcionValida: null,
      accionOtrosDescripcionInvalidaMsj: '',
      titularValido: null,
      titularInvalidoMsj: '',
      mecanicaValida: null,
      mecanicaInvalidaMsj: '',
      premiosValido: null,
      premiosInvalidoMsj: '',
      pieLegalValido: null,
      pieLegalInvalidoMsj: '',
      piezasValido: null,
      piezasInvalidoMsj: '',
      requerimientosDisenioValido: null,
      requerimientosDisenioInvalidoMsj: '',
      formaEntregaOtrosDescripcionValida: null,
      formaEntregaOtrosDescripcionInvalidaMsj: '',
      fechaEntregaMuestraValida: null,
      fechaEntregaMuestraInvalidaMsj: '',
      fechaEntregaOriginalesValida: null,
      fechaEntregaOriginalesInvalidaMsj: '',
      fechaImplementacionValida: null,
      fechaImplementacionInvalidaMsj: '',

      fechaEntregaMuestraDisabled: true,
      fechaEntregaOriginalesDisabled: true,
      fechaImplementacionDisabled: true,

      labelCols: 2,
      tabIndex: 0,
      
      marcaId: 0,
      marcaRowVersion: null,

      // texto: '',
      // editorOptions: {
      //   hideModules: {
      //     image: true,
      //     code: true,
      //     heading: true
      //   },
      //   maxHeight: '300px',
      //   minHeight: '150px',
      //   locale: 'es'
      // }
    }
  },
  computed: {
    ...mapFields([
      'id',
      // 'presupuestoNumero',
      'clienteId',
      'cliente',
      'clienteNombre',
      'accion',
      'tipoPresupuestoId',
      'tipoPresupuesto',
      'tipoPresupuestoNombre',
      'canal',
      'canalNombre',
      'subcliente',
      'descripcion',
      'descripcionAdicionales',
      'accionPuntoVenta',
      'accionConsumidorFinal',
      'accionFuerzaVenta',
      'accionOtros',
      'accionOtrosDescripcion',
      'titular',
      'mecanica',
      'premios',
      'pieLegal',
      'piezas',
      'requerimientosDisenio',
      'formaEntregaEditable',
      'formaEntregaDigital',
      'formaEntregaImpresion',
      'formaEntregaAdaptacion',
      'formaEntregaIndefinida',
      'formaEntregaOtros',
      'formaEntregaOtrosDescripcion',
      'fechaEntregaMuestra',
      'fechaEntregaMuestraHabilitada',
      'fechaEntregaOriginales',
      'fechaEntregaOriginalesHabilitada',
      'fechaImplementacion',
      'fechaImplementacionHabilitada',
      'especificacionesProduccion',

      'tiposDisenios',
      'canales',
      'canalesList',
      'presupuestosInternos',
      'tiposPresupuestos',
      'tiposPresupuestosList',

      // 'cambios',
      // 'muestras',
      // 'originales',
      'isDirtySaved'
    ]),
    mecanicaPromocionalVisible() {
      /* Unicamente visible si está activa la primer pestaña (especificaciones) */
      if (this.tabIndex == 0) {
        if (this.tiposDisenios) {
          let mecanicaPromocional = this.tiposDisenios.find(t => (/true/i).test(t.mecanicaPromocional));
          
          if (mecanicaPromocional) {
            return (/true/i).test(mecanicaPromocional.seleccionado);
          }
        }
      }

      return false;
    },
    isAccionOtros() {
      return (/true/i).test(this.accionOtros);
    },
    isFormaEntregaOtros() {
      return (/true/i).test(this.formaEntregaOtros);
    },
    tituloModalMarcas() {
      if (this.marcaId == 0) {
        return 'Nueva Marca';
      }

      return 'Editar Marca';
    },
    presupuestosNumero() {
      if (this.presupuestosInternos) {
        return this.presupuestosInternos.map(({ presupuestoNumero }) => presupuestoNumero).join(' | ');
      }

      return '';
    }
  },  
  created() {
    let briefId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        briefId = this.$route.params.id;
      }
    }

    this.showSpinner();
    this.$store.dispatch('brief/inicializar', briefId)
      .then(() => {
        this.fechaEntregaMuestraDisabled = !(/true/i).test(this.fechaEntregaMuestraHabilitada);
        this.fechaEntregaOriginalesDisabled = !(/true/i).test(this.fechaEntregaOriginalesHabilitada);
        this.fechaImplementacionDisabled = !(/true/i).test(this.fechaImplementacionHabilitada);
        this.$refs.tiposDisenios.refresh();
      })
      .catch(error => this.showErrorMsj(error))
      .finally(() => {
        this.hideSpinner();

        /* Actualizo isDirty luego de cargar el brief */
        this.$store.dispatch('brief/setClean');
      })
  },
  methods: {
    setTabIndex(e) {
      this.tabIndex = parseInt(e);
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'accion' || validarTodos) {
        if (this.$v.accion.$error) {
          this.accionValida = false;
          if (!this.$v.accion.required) {
            this.accionInvalidaMsj= 'Debe ingresar el nombre de la acción.';
          } else if (!this.$v.accion.maxLength) {
            this.accionInvalidaMsj = 'El nombre de la acción solo puede contener hasta 50 caracteres';
          }      
        } else {
          this.accionValido = null;
          this.accionInvalidoMsj = '';
        }
      }

      if (campo == 'subcliente' || validarTodos) {
        if (this.$v.subcliente.$error) {
          this.subclienteValido = false;
          if (!this.$v.subcliente.required) {
            this.subclienteInvalidoMsj= 'Debe ingresar el subcliente de la acción.';
          } else if (!this.$v.subcliente.maxLength) {
            this.subclienteInvalidoMsj = 'El nombre del subcliente solo puede contener hasta 150 caracteres';
          }      
        } else {
          this.subclienteValido = null;
          this.subclienteInvalidoMsj = '';
        }
      }

      if (validarTodos)
        this.$refs.totales.displayErrores();
    },
    save (saveContinue) {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      this.$v.$touch();

      let save = true;

      if (this.id == 0) {
        let errorCliente = true;
        if (this.clienteId) {
            errorCliente = this.clienteId == 0;
        }

        if (errorCliente) {
          this.clienteValido = false;
          this.clienteInvalidoMsj = 'Debe seleccionar el cliente correspondiente.';
          save = false;
        }

        let errorTipoPresupuesto = true;
        if (this.tipoPresupuestoId) {
          errorTipoPresupuesto = this.tipoPresupuestoId == 0;
        }

        if (errorTipoPresupuesto) {
          this.tipoPresupuestoValido = false;
          this.tipoPresupuestoInvalidoMsj = 'Debe seleccionar el tipo de presupuesto correspondiente.';
          save = false;
        }
      }

      if (save) {
        if (this.$v.$anyError) {
          this.displayErrores();
        } else {
          if (this.id == 0) {
            /* Validamos si agregamos un brief con cliente + accion correspondientes a un PI existente */
            let params = {
              clienteId: this.clienteId,
              accion: this.accion
            }
            
            this.showSpinner();
            this.$store.dispatch('presupuestosinternos/existsPresupuestoByClienteAccion', params)
              .then(() => {
                this.hideSpinner();
                
                let existPresupuesto = (/true/i).test(this.$store.getters['presupuestosinternos/existsPresupuesto']);

                if (existPresupuesto) {
                  this.showModalConfirm('El cliente y la acción ingresados corresponden a un presupuesto interno existente, si registra el brief se asociará a ese presupuesto. ¿Confirma registrar el nuevo brief?', 
                    this.saveBrief.bind(this, saveContinue), 'Si', null, 'No');
                } else {
                  this.saveBrief(saveContinue);
                }
              })
              .catch(error => this.showErrorMsj(error))
              .finally(() => this.hideSpinner());
          } else {
            this.saveBrief(saveContinue);
          }
        }
      }
    },
    saveBrief(saveContinue) {
      let isDirty = (/true/i).test(this.$store.getters['brief/dirty']);

      this.showSpinner();
      this.$store.dispatch('brief/save')
        .then(() => {
          if (!saveContinue) {
            if (this.id != 0 && (isDirty || (/true/i).test(this.isDirtySaved))) {
              this.showModalConfirm('Los cambios se registraron con éxito. ¿Desea enviar una notificación a los usuarios asignados?', 
                this.sendNotificacionesCambios.bind(this), 'Si', this.goList, 'No');
            } else {
              this.showModalMsj('Los cambios se registraron con éxito', this.goList, this.goList, 'light');
            }
          }
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    sendNotificacionesCambios() {
      this.showSpinner();
      this.$store.dispatch('brief/sendNotificacionesCambios')
        .catch(error => this.showErrorMsj(error))
        .finally(() => {
          this.hideSpinner();
          this.$router.push({ name: 'Briefs' });
        });
    },
    seleccionarCliente() {
      if (this.cliente) {
        this.$store.dispatch('brief/setCliente', null)
      } else {
        this.$refs.searchClienteModal.show();
      }
    },
    clienteSeleccionado(cliente) {
      this.$refs.searchClienteModal.hide();

      this.$store.dispatch('brief/setCliente', cliente)
        .then(() => this.$refs.marcas.refresh())
        .catch(error => this.showErrorMsj(error));

      this.clienteValido = null;
      this.clienteInvalidoMsj = '';
    },
    tipoPresupuestoActualizado(tipoPresupuestoNombre) {
      let tipoPresupuesto = this.getSelected(this.tiposPresupuestos, tipoPresupuestoNombre);

      this.$store.dispatch('brief/setTipoPresupuesto', tipoPresupuesto)
        .catch(error => this.showErrorMsj(error))

      this.tipoPresupuestoValido = null;
      this.tipoPresupuestoInvalidoMsj = '';
    },
    canalActualizado(canalNombre) {
      let canal = this.getSelected(this.canales, canalNombre);

      this.$store.dispatch('brief/setCanal', canal)
        .catch(error => this.showErrorMsj(error))

      this.canalValido = null;
      this.canalInvalidoMsj = '';
    },
    goList() {
      this.$router.push({ name: 'Briefs' });
    },
    cancel() {
      let isDirty = (/true/i).test(this.$store.getters['brief/dirty']);

      if (isDirty) {
        this.showModalConfirm('¿Desea abandonar el brief sin guardar la información?', 
              this.cancelar, 'Si', null, 'No');
      } else if ((/true/i).test(this.isDirtySaved)) {
        this.showModalConfirm('¿Desea enviar una notificación a los usuarios asignados por los cambios realizados en el brief?', 
          this.sendNotificacionesCambios.bind, 'Si', this.goList, 'No');
      } else {
        this.goList();
        // this.cancelar();
      }
    },
    cancelar() {
      this.showSpinner();
      this.$store.dispatch('brief/cancel')
        .then(() => this.$router.push({ name: 'Briefs' }))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },

    agregarMarca() {
      if (this.clienteId == 0) {
        this.showErrorMsj(new Error('Debe seleccionar el cliente en primer término para agregar una nueva marca.'));
      } else {
        this.marcaId = 0;
        this.marcaRowVersion = null;
        this.$refs.marcaModal.show();
      }
    },
    editarMarca(marca) {
      this.marcaId = marca.marcaId;
      this.marcaRowVersion = marca.rowVersion;
      this.$refs.marcaModal.show();
    },
    marcaSaved (marca) {
      this.$refs.marcaModal.hide();
      if (marca) {
        if (this.marcaId == 0) {
          this.$store.dispatch('brief/addMarca', marca)
            .then(() => this.$refs.marcas.refresh())
            .catch(error => this.showErrorMsj(error))
        } else {
          this.$store.dispatch('brief/updateMarca', marca)
            .then(() => this.$refs.marcas.refresh())
            .catch(error => this.showErrorMsj(error))
        }
      }
    },
    closeMarca() {
      this.$refs.marcaModal.hide();
    },
    addPresupuestoInterno() {
      this.$refs.searchPresupuestoInternoModal.show();
    },
    presupuestoInternoSeleccionado(params) {
      this.$refs.searchPresupuestoInternoModal.hide();
      let presupuestoInterno = params.presupuestoInterno || {};
      this.$store.dispatch('brief/addPresupuestoInterno', presupuestoInterno)
        .then(() => this.$refs.presupuestosInternos.refresh())
        .catch(error => this.showErrorMsj(error));
    },
    cancelaSeleccionPresupuestoInterno() {
      this.$refs.searchPresupuestoInternoModal.hide()
    },
    deletePresupuestoInterno(presupuestoInternoId) {
      this.$store.dispatch('brief/deletePresupuestoInterno', presupuestoInternoId)
        .then(() => this.$refs.presupuestosInternos.refresh())
        .catch(error => this.showErrorMsj(error))
    },
  },
  validations: {
    accion: {
      required,
      maxLength: maxLength(50)
    },
    subcliente: {
      maxLength: maxLength(150)
    },
    descripcion: {
    },
    accionOtrosDescripcion: {
      maxLength: maxLength(150)
    },
    titular: {
      maxLength: maxLength(150)
    },
    mecanica: {
      // maxLength: maxLength(150)
    },
    premios: {
      // maxLength: maxLength(150)
    },
    pieLegal: {
      // maxLength: maxLength(150)
    },
    piezas: {
      // maxLength: maxLength(150)
    },
    requerimientosDisenio: {
      // maxLength: maxLength(150)
    },
    formaEntregaOtrosDescripcion: {
      maxLength: maxLength(150)
    },
    fechaEntregaMuestra: {},
    fechaEntregaOriginales: {},
    fechaImplementacion: {}
  },  
  watch: {
    'fechaEntregaMuestraHabilitada' : function(newVal, oldVal) {
      this.fechaEntregaMuestraDisabled = !(/true/i).test(this.fechaEntregaMuestraHabilitada);
    },
    'fechaEntregaOriginalesHabilitada' : function(newVal, oldVal) {
      this.fechaEntregaOriginalesDisabled = !(/true/i).test(this.fechaEntregaOriginalesHabilitada);
    },
    'fechaImplementacionHabilitada' : function(newVal, oldVal) {
      this.fechaImplementacionDisabled = !(/true/i).test(this.fechaImplementacionHabilitada);
    },
    // 'texto'() {
    //   console.log(this.texto);
    // }
  }    
}
</script>

<style>
/*
  .brief-card-header .card-body {
    padding: 0;
  }
  .brief-card-header .card-body > div {
    padding: 20px;
  }

  .brief-card-header .card-header-add.btn-primary {
    position: absolute;
    padding: 0;
    height: 22px;
    width: 22px;
    top: 12px;
    left: 110px;
    border-radius: 30px;
  }
  .brief-card-header .card-header-add i.fa-plus {
    position: relative;
    top: 0;
  }
*/
  .brief-abm .tabs .tab-pane {
    min-height: 400px;
    padding-top: 30px;
  }
  .brief-abm hr {
    /* margin-bottom: 50px; */
    margin-bottom: 30px; 
    margin-top: 30px;
  }
  .brief-abm .custom-check-input {
    margin-left: 30px;
  }
  .brief-abm li {
    list-style: circle;
  }
  .brief-abm li.nav-item {
    list-style: none;
  }

  .brief-abm .brief-header .card-body {
    padding: 0;
  }
  .brief-abm .brief-header .card-body > div {
    padding: 20px;
  }

  .brief-abm label.titulo {
    /* margin-top: 10px; */
    margin-bottom: 20px;
  }

  .brief-abm .titulo,
  .brief-abm .subtitulo {
    font-weight: 600;
  }

  .brief-abm .subtitulo,
  .brief-abm .subtitulo > label,
  .brief-abm .subtitulo > small {
    display: block;
  }

  .brief-abm .subtitulo {
    margin-bottom: 15px;
  }
  .brief-abm .subtitulo > label {
    margin-bottom: 3px;
  }

  .brief-abm .list-group .list-group-item {
    border-top: none;
    border-bottom: none;
    padding-top: 8px;
    padding-bottom: 8px;    
  }
  .brief-abm .list-group .list-group-item:first-child {
    border-top: none;
  }
  /* .brief-abm .list-group .list-group-item .input-group .custom-checkbox {
    top: 6px;
  } */
  .brief-abm .list-group .list-group-item .input-group input {
    top: -5px;
  }

  .brief-abm .list-group.accion-objetivos .list-group-item,
  .brief-abm .list-group.formas-entrega .list-group-item {
    padding-left: calc(16.66667% + 12px);
  }

  .brief-abm .especificaciones {
    margin-top: 30px;
  }

  /* .brief-abm .especificaciones ul {
    padding-left: calc(16.66667% + 12px);
  } */

  .brief-abm table th {
    border-top: none;
  }

  .brief-abm hr.separador-entregas {
    border-top: 1px solid rgba(0, 0, 0, 0.3);
  }

  .brief-abm .abm-save-continue-btn {
    top: -4px;
  }
</style>
